import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { createRouter } from './router'
import { createQueryClient } from '@/shared/lib/queryClient'
import { authReady, getSession, supabase } from '@/shared/lib/auth'
import { apiClient } from '@/shared/api/client'
import { applyLanguage, applyTheme, useAppStore } from '@/shared/stores/appStore'
import '@/shared/styles/global.css'

const queryClient = createQueryClient()

// Apply the persisted theme before first render to prevent a flash.
// 'system' removes the attribute and lets prefers-color-scheme decide.
applyTheme(useAppStore.getState().theme)
applyLanguage(useAppStore.getState().language)

// Initialize auth listener — sets session in appStore and ensures profile row exists
supabase.auth.onAuthStateChange((_event, session) => {
  useAppStore.getState().setSession(session)
  if (session) {
    const displayName =
      (session.user.user_metadata?.['display_name'] as string | undefined) ??
      `Jogador${Math.floor(1000 + Math.random() * 9000)}`
    // Fire-and-forget — idempotent upsert, errors are non-critical
    void apiClient.post('/v1/users/me', { displayName })
  }
})

getSession().then((session) => {
  useAppStore.getState().setSession(session)
})

const router = createRouter(queryClient)

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root not found')

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider
        router={router}
        context={{
          queryClient,
          auth: {
            session: useAppStore.getState().session,
            ready: authReady,
          },
        }}
      />
    </QueryClientProvider>
  </StrictMode>,
)
